<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">
        {{ "SIDEBAR_ANALYSIS_REPORT" | translate | uppercase }}
      </h6>
      @if(authService.isAuthorized([PermissionsEnum.Report_fraudulent_meters_view])){
      <div class="sidemenu-item-font item"
        (click)="navigate('analysis-report/fraudulent-meters')"
        [ngClass]="{ selected: isActive('analysis-report/fraudulent-meters') }">
        <span>{{ "ANALYSISREPORTMENU_GETFRAUDULENTMETERS" | translate }}</span>
      </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Report_prepayment_view])){
      <div class="sidemenu-item-font item"
        (click)="navigate('analysis-report/pre-payment-report')"
        [ngClass]="{ selected: isActive('analysis-report/pre-payment-report') }">
        <span>{{ "ANALYSISREPORTMENU_PREPAYMENTREPORT" | translate }}</span>
      </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Report_meter_time_sync_view])){
      <div class="sidemenu-item-font item"
        (click)="navigate('analysis-report/meter-time-sync')"
        [ngClass]="{ selected: isActive('analysis-report/meter-time-sync') }">
        <span>{{ "METERTIMESYNC" | translate }}</span>
      </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Scheduled_energyregister_view])){
        <div class="sidemenu-item-font item"
             (click)="navigate('analysis-report/energy-per-phase')"
             [ngClass]="{ selected: isActive('analysis-report/energy-per-phase') }">
          <span>{{ "REPORT_ENERGYPERPHASE" | translate }}</span>
        </div>
      }
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
